<template>
	<!-- 单选 -->
	<div class="p_m_t_30">
		<div class="p_flex">
			<div class="xuan type_size_22">题目内容</div>
			<div class="choice_input p_m_l_30">
				<question-wangeditor
					ref="childs"
					v-model="topicContent.title"
					:name="topic"
					:option="1"
					:height="120"
					:width="840"
					:val="topicVal"
				></question-wangeditor>
			</div>
		</div>
		<span class="type_size_22">选项</span>
		<div>
			<div class="p_flex p_m_t_30" v-for="(item, index) in topicContent.affiliation" :key="index">
				<div class="xuan type_size_22 p_flex p_f_e">
					<el-radio v-model="radio" @change='changeRadio'  :label="index">{{ engList[index] }}</el-radio>
				</div>
				<div class="choice_input p_m_l_30">
					<question-wangeditor ref="child" :option="engList[index]" :name="engList[index] + index" :height="120" :width="840" v-model="topicContent.affiliation[index].text" />
				</div>
				<div class="p_m_l_30 type_size_22 subject_color small_hand" @click="deleteEle(index)">删除</div>
			</div>
		</div>
		<div class="p_flex p_m_t_30">
			<div class="xuan type_size_22"></div>
			<div class="add_box p_m_l_30 small_hand" @click="addEle">添加选项</div>
		</div>
	</div>
</template>

<script>
import QuestionWangeditor from './questionWangeditor.vue';
import Info from '../../../assets/js/public.js';
export default {
	components: {
		QuestionWangeditor
	},
	data() {
		return {
			// 题目内容
			topic: 'topic',
			topicVal: '',
			name: '',
			// 选答案
			radio: 0,
			// 默认展开四组
			options: [],
			// 大写字母
			engList: [],
			arr: []
		};
	},
	props: {
		topicContent: {
			type: Object
			// default() {
			// 	return this.$refs['childs'].getHtml();
			// }
		},
		clear:null
	},
	watch:{
		clear(n,o){
			if( n ){
				this.$refs.childs.sing()
				var child = this.$refs.child
				for( var i = 0; i<child.length; i++ ){
					this.$refs.child[i].sing()
				}
				
			}
		}
	},
	created() {
		this.engList = Info.English;
		this.topicContent.answer = this.engList[this.radio]
		if (this.topicContent.affiliation.length == 0) {
			this.topicContent.affiliation = [
				{
					name: 'A',
					text: ''
				},
				{
					name: 'B',
					text: ''
				},
				{
					name: 'C',
					text: ''
				},
				{
					name: 'D',
					text: ''
				}
			];
		}
	},

	mounted() {
		this.options = Info.options;
	},
	methods: {
		goContinue() {
			const thta = this;
			var child = thta.$refs.child;
			for (var i = 0; i < child.length; i++) {
				thta.$refs.child[i].sing();
			}
			thta.$refs.childs.sing();
		},
		changeRadio(e){
			this.radio = e
			this.topicContent.answer = this.engList[e]
		},
		// 添加
		addEle() {
			for( var i = 0 ; i < this.topicContent.affiliation.length ;i++){
				var num = i + 1
			}
			this.topicContent.affiliation.push({
				name: this.engList[num],
				text: ''
			}); 
		},
		// 删除
		deleteEle(v) {
			this.topicContent.affiliation
			for( var i = 0 ; i<this.topicContent.affiliation.length; i++ ){
				if( v == i ){
					this.topicContent.affiliation.splice(i,1)
				}
				
			}
			for( var i = 0 ; i<this.topicContent.affiliation.length; i++ ){
				this.topicContent.affiliation[i].name = this.engList[i]
				
			}
			// this.topicContent.affiliation.splice(i,1)
		}
	}
};
</script>

<style lang="scss" scoped>
.choice_input {
	width: 840px;
}

.xuan {
	width: 88px;
}
>>> .el-radio__input.is-checked .el-radio__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-radio__input.is-checked + .el-radio__label {
	color: #00af63;
}
>>> .el-radio__inner {
	width: 20px;
	height: 20px;
}
>>> .el-radio__label {
	font-size: 18px;
}
>>> .el-radio__inner:hover {
	border-color: #999999;
}
.add_box {
	width: 94px;
	height: 33px;
	background: #fbb13c;
	border-radius: 6px;
	text-align: center;
	line-height: 33px;
	font-size: 14px;
	color: #ffffff;
}

>>> .el-radio__inner::after {
	width: 8px;
	height: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/singleChoice.vue